module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "viewBox": "0 0 20 20",
      "height": "20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M0,10.84V6.26A4.64,4.64,0,0,1,4.75,1.65h7.71a.44.44,0,0,0,.39-.19A4.09,4.09,0,0,1,17.33.22,3.9,3.9,0,0,1,20,3.93a3.68,3.68,0,0,1-.89,2.38.54.54,0,0,0-.14.38Q19,11,19,15.4a4.6,4.6,0,0,1-3.85,4.52,3.74,3.74,0,0,1-.82.08H4.79A4.63,4.63,0,0,1,0,15.36ZM17.8,7.35l-.24.1a4,4,0,0,1-4.13-.59A3.69,3.69,0,0,1,12.08,3c.05-.26.06-.26-.23-.26h-7A3.51,3.51,0,0,0,1.15,6.28c0,3,0,6.07,0,9.1A3.51,3.51,0,0,0,4.79,18.9h9.36a3.5,3.5,0,0,0,3.68-3.55V7.6A.44.44,0,0,0,17.8,7.35Zm1.05-3.46a2.87,2.87,0,0,0-5.73,0,2.87,2.87,0,0,0,5.73,0Z"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12.06,13.23c.38.12.75.21,1.11.33a5.8,5.8,0,0,1,2.44,1.49c.14.15.16.25,0,.38s-.38.36-.57.53-.09.09-.15,0a4.56,4.56,0,0,0-2.62-1.5,10.79,10.79,0,0,0-5.91.09A4.29,4.29,0,0,0,4.09,16C4,16,4,16,3.94,16l-.66-.63c-.11-.1,0-.16,0-.23a5.24,5.24,0,0,1,1.94-1.34,8.57,8.57,0,0,1,1.67-.52A4.13,4.13,0,0,1,5.08,9.81,3.94,3.94,0,0,1,6.56,6.67a4.54,4.54,0,0,1,6.1.23,3.93,3.93,0,0,1,1.21,3.3A4.13,4.13,0,0,1,12.06,13.23Zm.67-3.42A3.15,3.15,0,0,0,9.5,6.73,3.14,3.14,0,0,0,6.24,9.81a3.13,3.13,0,0,0,3.25,3.08A3.16,3.16,0,0,0,12.73,9.81Z"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M18,3.23a.5.5,0,0,1-.23.41c-.62.45-1.23.91-1.85,1.35a.55.55,0,0,1-.72,0c-.3-.21-.6-.43-.89-.66a.54.54,0,0,1-.12-.79A.61.61,0,0,1,15,3.45l0,0c.19.12.34.37.54.35s.37-.23.55-.36.65-.49,1-.72a.54.54,0,0,1,.62,0A.52.52,0,0,1,18,3.23Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47efa960","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/trainerRecommendations.vue
// module id = d90762ef194f2f904d80
// module chunks = 89